import { Component, Ref} from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class AddressesContainer extends ThemeComponent {
    @Ref() openEditAddress!: HTMLButtonElement[];
    @Ref() openNewAddress!: HTMLButtonElement;
    @Ref() editAddress!: HTMLElement[];
    @Ref() newAddress!: HTMLElement;

    init() {
        for (const editBtn of this.openEditAddress) {
            this.$listen(editBtn, 'click', () => {
                const editAddress =  editBtn.parentElement?.querySelector('[data-ref="editAddress"]');
                for (const address of this.editAddress) {
                    address.classList.add('hidden');
                }

                editAddress?.classList.remove('hidden');

                this.newAddress.classList.add('hidden');
                this.openNewAddress.classList.remove('hidden');
            });
        }

        this.$listen(this.openNewAddress, 'click', () => {
            this.openNewAddress.classList.add('hidden');
            this.newAddress.classList.remove('hidden');

            for (const address of this.editAddress) {
                address.classList.add('hidden');
            }
        });
    }
}
